'use strict';

angular.module('formonlineApp')
    .controller('CalculetteController', function ($scope, $log, $q, $stateParams, $translate, ContextFiscalService,
                                                  BaremeService, ErrorUtil, Language, ListUtils, IframeService) {
        const NB_JOURS_ANNEE = 360;
        const NB_JOURS_MOIS = 30;

        var vm = $scope;

        vm.baremes = [];
        vm.baremesSansRevenuDeterminant = [];
        vm.baremesEnfantObligatoire = [];
        vm.baremesAvecEnfants = [];

        vm.calcul = {};
        vm.calcul.bareme = null;
        vm.calcul.nbDeJours = NB_JOURS_ANNEE;
        vm.calcul.baseCalculMensuel = 30;
        vm.calcul.anneesFiscales = [];
        vm.calcul.anneeFiscale = null;
        vm.calcul.revenuBrut = 60000;
        vm.calcul.nbEnfants = 0;
        vm.calcul.etatCivil = 'INCONNU';
        vm.calcul.tauxActivite = 1;
        vm.calcul.tauxAutresActivites = 0;
        vm.calcul.extrapolerSurTauxActivite = true;
        vm.calcul.travailDiscontinu = false;
        vm.calcul.nbHeuresTravail = 0;
        vm.calcul.errorMsg = null;
        vm.calcul.revenuMensuel = false;

        if ($stateParams.locale) {
            $translate.use($stateParams.locale);
        } else {
            $translate.use('fr');
        }

        var getCodeCalculetteByAnnee = function () {
            return BaremeService.getCodeCalculetteByAnnee(vm.calcul.anneeFiscale).then(function (response) {
                vm.baremes = response.data;
            }).catch(function (error) {
                $log.error('Erreur appel ws /bareme/annee/' + vm.calcul.anneeFiscale + '/calculette');
                $log.error(error);
                vm.calcul.errorMsg = ErrorUtil.translateError(error, 'error.error.internalServerError', 'error.');
            });
        }

        var getCodeCalculetteSansRevenuDeterminantByAnnee = function () {
            return BaremeService.getCodeCalculetteSansRevenuDeterminantByAnnee(vm.calcul.anneeFiscale).then(function (response) {
                vm.baremesSansRevenuDeterminant = response.data;
            }).catch(function (error) {
                $log.error('Erreur appel ws /bareme/annee/' + vm.calcul.anneeFiscale + '/calculettesansrevenudeterminant');
                $log.error(error);
                vm.calcul.errorMsg = ErrorUtil.translateError(error, 'error.error.internalServerError', 'error.');
            });
        }

        var getCodeCalculetteEnfantObligatoireByAnnee = function () {
            return BaremeService.getCodeCalculetteEnfantObligatoireByAnnee(vm.calcul.anneeFiscale).then(function (response) {
                vm.baremesEnfantObligatoire = response.data;
            }).catch(function (error) {
                $log.error('Erreur appel ws /bareme/annee/' + vm.calcul.anneeFiscale + '/calculetteenfantobligatoire');
                $log.error(error);
                vm.calcul.errorMsg = ErrorUtil.translateError(error, 'error.error.internalServerError', 'error.');
            });
        }

        var getCodeCalculetteAvecEnfantsByAnnee = function () {
            return BaremeService.getCodeCalculetteAvecEnfantsByAnnee(vm.calcul.anneeFiscale).then(function (response) {
                vm.baremesAvecEnfants = response.data;
            }).catch(function (error) {
                $log.error('Erreur appel ws /bareme/annee/' + vm.calcul.anneeFiscale + '/calculetteavecenfants');
                $log.error(error);
                vm.calcul.errorMsg = ErrorUtil.translateError(error, 'error.error.internalServerError', 'error.');
            });
        }

        var getByAnnee = function () {
            return ContextFiscalService.getByAnnee(vm.calcul.anneeFiscale).then(function (response) {
                vm.calcul.cf = response.data;
            }).catch(function (error) {
                $log.error('Erreur appel ws /contextefiscal');
                $log.error(error);
                vm.calcul.errorMsg = ErrorUtil.translateError(error, 'error.error.internalServerError', 'error.');
            });
        }

        var loadBaremeLists = function () {
            return $q.all([getCodeCalculetteByAnnee(),
                getCodeCalculetteSansRevenuDeterminantByAnnee(),
                getCodeCalculetteEnfantObligatoireByAnnee(),
                getCodeCalculetteAvecEnfantsByAnnee(),
                getByAnnee()]);
        }

        var init = function () {
            $scope.$on('cfpLoadingBar:completed', function () {
                vm.sendHeightToParent();
            });

            ContextFiscalService.getAnneesFiscales().then(function (response) {
                vm.calcul.anneesFiscales = response.data;
                var thisYear = new Date().getFullYear();
                angular.forEach(vm.calcul.anneesFiscales, function (val) {
                    if (val === thisYear) {
                        vm.calcul.anneeFiscale = val;
                        return;
                    }
                });
                if (!vm.calcul.anneeFiscale) {
                    vm.calcul.anneeFiscale = value[0];
                }
                vm.anneeFiscaleSelected();
            }).catch(function (error) {
                $log.error('Erreur appel ws /contextefiscal');
                $log.error(error);
                vm.calcul.errorMsg = ErrorUtil.translateError(error, 'error.error.internalServerError', 'error.');
            });
        }

        init();

        //Fonction pour les appels depuis le template
        vm.sendHeightToParent = function() {
            IframeService.sendHeightToParent('calculis-form-content-wrapper');
        }

        vm.getLanguage = function() {
            return Language.current();
        };

        vm.anneeFiscaleSelected = function () {
            if (vm.calcul.anneeFiscale) {
                vm.calcul.travailDiscontinu = false;
                vm.calcul.tauxActivite = 1;
                vm.calcul.tauxAutresActivites = 0;
                vm.calcul.nbHeuresTravail = null;
                vm.calcul.bareme = null;

                loadBaremeLists().then(function () {
                    vm.resetRevenuDeterminantEtCalculer();
                }).catch(function (error) {
                    $log.error('Erreur lors du chargement des barèmes')
                    $log.error(error);
                });
            }
        };

        vm.calculer = function () {
            try {
                if (vm.calcul.bareme && vm.calcul.revenuBrut
                    && (!this.isBaremeAvecEnfants(vm.calcul.bareme) || Number.isInteger(vm.calcul.nbEnfants))
                    && !vm.calculisForm.$invalid) {

                    if (this.isBaremeEnfantObligatoire(vm.calcul.bareme) && vm.calcul.nbEnfants < 1) {
                        vm.calcul.nbEnfants = 1;
                    }
                    if (this.isBaremeSansRevenuDeterminant(vm.calcul.bareme) || !this.isBaremeAvecEnfants(vm.calcul.bareme)) {
                        vm.calcul.nbEnfants = 0;
                    }
                    vm.calcul.nbDeJours = vm.calcul.revenuMensuel ? NB_JOURS_MOIS : NB_JOURS_ANNEE;
                    BaremeService.calculerCoteByNbJours(vm.calcul.nbDeJours, vm.calcul.cf, vm.calcul.bareme, vm.calcul.nbEnfants, vm.calcul.revenuBrut, null /* revenuConjoint */,
                        vm.calcul.tauxActivite, vm.calcul.tauxAutresActivites, vm.calcul.travailDiscontinu, vm.calcul.nbHeuresTravail,
                        null /* retenue */, null /* commission */, vm.calcul.revenuDeterminant /* revenuDeterminant */, null /* dossierTauxCommission */, vm.calcul.etatCivil, 0 /* nbPersonnes*/)
                        .then(function (response) {
                            var value = response.data;
                            vm.calcul.taux = value.taux / 100;
                            vm.calcul.retenue = value.retenue;
                            vm.calcul.revenuDeterminant = value.revenuDeterminant;
                            vm.calcul.computedRevenuDeterminant = value.revenuDeterminantCalcule;
                        }).catch(function (error) {
                            $log.error('Erreur appel ws /bareme/cote');
                            $log.error(error);
                            vm.calcul.errorMsg = ErrorUtil.translateError(error, 'error.error.internalServerError', 'error.');
                        });
                } else {
                    vm.calcul.taux = null;
                    vm.calcul.retenue = null;
                    vm.calcul.revenuDeterminant = null;
                    vm.calcul.computedRevenuDeterminant = null;
                }
            } catch (error) {
                $log.error(error);
                vm.calcul.errorMsg = $translate.instant('error.error.internalServerError');
            }
        };

        vm.isBaremeSansRevenuDeterminant = function (bareme) {
            return ListUtils.isStringInList(vm.baremesSansRevenuDeterminant, bareme);
        };

        vm.isBaremeEnfantObligatoire = function (bareme) {
            return ListUtils.isStringInList(vm.baremesEnfantObligatoire, bareme);
        };

        vm.isBaremeAvecEnfants = function (bareme) {
            return ListUtils.isStringInList(vm.baremesAvecEnfants, bareme);
        };

        vm.activiteChange = function() {
            vm.calcul.nbHeuresTravail = null;
            vm.calcul.tauxActivite = null;
            vm.calcul.tauxAutresActivites = null;
            if(vm.calcul.travailDiscontinu) {
                vm.calcul.nbHeuresTravail = 1;
            } else {
                vm.calcul.tauxActivite = 1;
                vm.calcul.tauxAutresActivites = 0;
            }
            vm.resetRevenuDeterminantEtCalculer();
        }

        vm.isRevenuDeterminantModified = function () {
            if (!vm.calcul.revenuDeterminant || !vm.calcul.computedRevenuDeterminant) {
                return false;
            }
            return vm.calcul.revenuDeterminant !== vm.calcul.computedRevenuDeterminant;
        };

        vm.resetRevenuDeterminantEtCalculer = function () {
            vm.calcul.revenuDeterminant = null;
            vm.calcul.computedRevenuDeterminant = null;
            vm.calculer();
        }

    });
